import React from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { CiSearch } from "react-icons/ci";
import { TbFilterSearch } from "react-icons/tb";
import { useEventsContext } from "../EventsContext/EventsContext";

const EventSearchToolbar = () => {
  const {
    setSortOptionSelected,
    sortOptions,
    handleShowFilterModal,
    filters,
    setFilters,
  } = useEventsContext();

  return (
    <>
      <div className="container">
        <InputGroup className="mb-3 mt-10">
          <Form.Control
            placeholder="search"
            aria-label="search"
            aria-describedby="basic-addon1"
            onChange={(e) => {
              let newFilters = { ...filters };
              newFilters["keyword"] = e.target.value.toString();
              setFilters(newFilters);
            }}
          />

          <InputGroup.Text id="basic-addon1">
            <CiSearch />
          </InputGroup.Text>
        </InputGroup>
        <div className="row justify-content-end">
          <div className="col-lg-2 events-mobile-filter">
            <button className="btn btn-muted" onClick={handleShowFilterModal}>
              <TbFilterSearch />
            </button>
          </div>

          <div className="col-lg-4 d-flex flex-row align-items-center">
          <lable className="mb-30 mr-10 h4">Sort: </lable>
            <select
              className="form-select"
              onChange={(e) => {
                setSortOptionSelected(e.target.value);
              }}
            >
              {sortOptions &&
                sortOptions.map((sO) => {
                  return (
                    <option key={sO.value} value={sO.value}>
                      {sO.label}
                    </option>
                  );
                })}
            </select>
          </div>
        </div>
      </div>
    </>
  );
};

export default EventSearchToolbar;
